import axios from '@/libs/api.request'

export const getCoupon = (data) => {
  return axios.request({
    url: '/print/coupon',
    params: data,
    method: 'get'
  })
}
export const saveCoupon = (data) => {
  return axios.request({
    url: '/print/coupon',
    data: data,
    method: 'put'
  })
}
export const getCouponAll = (data) => {
  return axios.request({
    url: '/print/coupon/list',
    params: data,
    method: 'get'
  })
}
